<template>
<v-card dark flat style='min-height:100%;'>
  <v-progress-linear
    v-if='request.loading'
    indeterminate :height='2' class='ma-0' >
  </v-progress-linear>
  <v-card-text v-if='comm.backend_used === "services.backends.email.EmailBackend"' >
    <div>
      <div class='overline' >To:</div><v-chip class='v-chip--x-small' v-for='email in comm.recipient_emails' :key='email' >{{email}}</v-chip>
    </div>
    <v-divider></v-divider>
    <div>
      <div class='overline mt-2' >Subject:</div> {{comm.subject}}
    </div>
    <v-divider></v-divider>
    <div class='mt-4 overline' >Message:</div>
    <div v-html='parsedMessage' class="block" >
    </div>
  </v-card-text>
  <v-card-text v-if='comm.backend_used === "services.backends.zoomconnect.ZoomSMSBackend"' >
    <div>
      <span class='overline' >To:</span><v-chip class='v-chip--x-small' >{{comm.recipient_phone_number}}</v-chip>
    </div>
    <v-divider></v-divider>
    <div class='mt-4 mb-2 overline' >Message:</div>
    <pre ><code class='pa-2' style="width:100%;" >{{comm.short_message.trim()}}</code>
    </pre>
  </v-card-text>
  <v-divider></v-divider>
  <!-- <v-card-actions >
    <v-chip outline label color='success' >
      <v-avatar left >
        <v-icon>done</v-icon>
      </v-avatar>
      {{comm.status}}
    </v-chip>
  </v-card-actions> -->
  <v-list dense >
    <h4 class='overline ml-3 mb-2' >Status history</h4>
    <v-list-tile v-for='status in comm.communicationstatus' :key='status.id' >
      <v-list-tile-content>
        <v-list-tile-title>{{status.status}}</v-list-tile-title>
        <v-list-tile-sub-title >{{ dateformat(status.created_date, 'ddd DD MMM YYYY H:mma') }}</v-list-tile-sub-title>
      </v-list-tile-content>
    </v-list-tile>
  </v-list>

  <!-- <stream resource='ag.practitioner.appointments' resource-id='319755'  /> -->
  <!-- <stream resource='unibox.comms' :resource-id='comm.id' title="Feed" /> -->
</v-card>
</template>
<script>
// import Stream from '@/components/ui/Stream.vue'
import * as DOMPurify from 'dompurify'
export default {
  name: 'CommunicationCard',
  // components: {Stream},
  props: {
    id: { required: true },
    initialData: { type: Object, default: () => { return {} } },
    withFetch: { type: Boolean, default: true }
  },
  data () {
    return {
      reqId: 'get-communication',
      comm: {}
    }
  },
  mounted () {
    if (this.initialData) {
      this.comm = this.initialData
    }
    // if (this.withFetch) {
    //   this.fetch()
    // }
  },
  watch: {
    id: {
      immediate: true,
      handler () {
        this.fetch()
      }
    },
    requestStatus () {
      if (this.requestStatus === 200) {
        this.comm = this.serverComm
      }
    }
  },
  computed: {
    request () {
      return this.$store.getters.getRequestById(this.reqId)
    },
    requestStatus () {
      return this.request.status
    },
    serverComm () {
      return this.getObjectPath(this.request, 'result.data', {})
    },
    parsedMessage () {
      if (this.comm && this.comm.message) {
        // althought the response is probably html, we use marked to sanitize the data:
        return DOMPurify.sanitize(this.comm.message, { USE_PROFILES: { html: true } })
        // return marked(this.comm.message)
      }
      return ''
    }
  },
  methods: {
    fetch () {
      if (this.id) {
        this.$communicationguru
          .resource('communication')
          .id(this.reqId)
          .get(this.id)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// CommunicationCard.vue?578f0432